export { default } from './GiftCardMessage';



// WEBPACK FOOTER //
// ./src/app/giftCard/GiftCardMessage/index.js